var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNonDyslexicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "-23.5 56.5 32 32",
    enableBackground: "new -23.5 56.5 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-5.927,77.875c-0.186,0.48-0.439,0.944-0.756,1.396c-1.168,1.482-2.799,2.229-4.9,2.229 c-0.742,0-1.433-0.105-2.07-0.32c-1.99-0.66-2.985-2.132-2.985-4.417c0.025-3.533,3.518-5.351,10.47-5.457v-2.55 c0-0.506-0.022-0.97-0.075-1.394c-0.267-1.884-1.198-2.828-2.791-2.828c-0.425,0-0.809,0.08-1.153,0.239 c-0.504,0.267-0.916,0.944-1.236,2.032c-0.106,0.319-0.186,0.543-0.238,0.678c-0.369,0.98-1.035,1.471-1.991,1.471 c-0.238,0-0.479-0.037-0.716-0.118c-0.852-0.266-1.274-0.85-1.274-1.754c0-0.476,0.146-0.928,0.437-1.354 c0.983-1.486,3.146-2.229,6.492-2.229c0.744,0,1.448,0.066,2.111,0.198c3.24,0.639,4.86,2.671,4.86,6.093v8.361 c0,1.278,0.302,1.94,0.914,1.993c0.795-0.024,1.274-0.969,1.435-2.824l1.033,0.04c-0.052,0.738-0.146,1.378-0.277,1.911 C0.911,80.754-0.26,81.5-2.146,81.5C-4.239,81.474-5.503,80.262-5.927,77.875z M-8.714,79.59c1.247-0.56,2.099-1.737,2.546-3.548 v-3.623c-1.326,0.026-2.413,0.16-3.261,0.4c-1.806,0.479-2.709,1.622-2.709,3.422c0,0.134,0,0.268,0,0.397 c0.107,2.127,0.903,3.185,2.389,3.185C-9.429,79.824-9.086,79.751-8.714,79.59z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonDyslexicIcon);
export default __webpack_public_path__ + "static/media/Non-dyslexicIcon.89a81e8f.svg";
export { ForwardRef as ReactComponent };